import React, { useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import ProfileForm from '../../components/pageModule/Profiles/ProfileForm';
import { updateProfile, fetchProfile, setSelected, clearCurrentProfile } from '../../store/modules/profile/profileActions';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const ProfilesEdit = () => {
    const profileState = useSelector(state => state.profile);
    const dispatch = useDispatch();
    const { id } = useParams();
    const isInitialized = useRef(false);

    const handleUpdate = async (formData) => {
        try {
            const response = await dispatch(updateProfile(id, formData));
            toast.success('Profile updated successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error updating profile', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        fetchSingle: (id) => dispatch(fetchProfile(id)),
        update: handleUpdate,
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
        clearCurrent: () => dispatch(clearCurrentProfile())
    };

    // Fetch function with proper dependencies using actions
    const fetchData = useCallback(async (id) => {
        try {
            const data = await actions.fetchSingle(id);
            if(data) {
                const selectedIds = data.items.map(item => item?.item?.id);
                await actions.setItemsSelected({
                    key: 'itemIds',
                    data: selectedIds
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [actions]);

    // Initial data fetch
    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;
            fetchData(id);
        }
    }, [fetchData, id]);

    // Cleanup when component unmounts
    useEffect(() => {
        return () => {
            actions.clearCurrent();
        };
    }, [actions]);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <ProfileForm 
                                    initialData={profileState.current}
                                    onSave={async (data) => {
                                        try {
                                            const response = await actions.update(data);
                                            return response;
                                        } catch (error) {
                                            console.error('Error updating profile:', error);
                                            throw error;
                                        }
                                    }}
                                    onClose={() => {
                                        console.log('cancel btn clicked')
                                    }}
                                    customActionsDispatch={actions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ProfilesEdit; 